<template>

    <app-layout>


        <div class="-mt-6 flex flex-grow flex-col bg-white relative" >

            <div class="absolute top-0 left-0 w-full h-full flex flex-grow flex-col opacity-20" style=""></div>

            <div class=" z-10 flex flex-col mx-auto justify-center items-center flex-grow ">

                <div class="p-10 rounded-xl bg-white flex flex-col items-center justify-center gap-y-6">

                    <LockClosedIcon class="size-8 text-gray-800" />

                    <h1 class="text-center font-bold text-base mt-3 text-gray-800">Private video access</h1>

                    <h4 v-if="!link_sent && !error" class="text-center text-base mt-3 text-gray-800">To watch it, click the button below to receive a secure access link via email:</h4>

                    <h4 v-else-if="link_sent" class="text-center text-base mt-3 text-gray-800 flex items-center">
                        <span>A link was sent to your email!</span>
                    </h4>

                    <h4 v-if="link_sent" class="text-center font-light text-lg mt-3 text-gray-800 flex items-center">
                        <span class="font-bold">Check your mailbox</span> <EnvelopeOpenIcon class="w-4 h-4 ml-2" />
                    </h4>

                    <h4 v-if="error" class="text-center text-base mt-3 text-red-800 flex items-center">
                        <ExclamationCircleIcon class="w-4 h-4 mr-2" />
                        <span>An error occured when sending the link, please retry within a few seconds… If the error persists contact the sender of this link.</span></h4>

                    <div class="text-center font-light text-lg text-gray-500 flex flex-col mt-3">

                        <button v-if="!sending_link && !link_sent" class="inline-flex items-center px-4 py-2 bg-gray-900  border-transparent rounded-md text-sm text-white uppercase tracking-widest hover:opacity-90 font-medium  disabled:opacity-25 transition"
                        @click="sendLink">Get secure link
                            <PaperAirplaneIcon class="w-4 h-4 ml-2" />
                        </button>

                        <div v-else-if="!link_sent && !error" class="inline-flex items-center justify-between px-4 py-2 bg-birdie-blue border-transparent rounded-md font-bold text-sm text-white uppercase tracking-widest transition gap-x-16">
                            <span>Sending…</span>
                            <spinner class="h-4 w-4 text-white"></spinner>
                        </div>

                        <div v-else-if="!error" class="text-center font-light text-gray-800 flex items-center text-sm">
                            Check your spam folder. If you don’t receive the secure link shortly, contact the sender to verify your access.
                        </div>


                    </div>




                </div>

            </div>


        </div>

    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import { LockClosedIcon, ArrowRightIcon, PaperAirplaneIcon, EnvelopeOpenIcon, ExclamationCircleIcon } from "@heroicons/vue/24/outline";

    import Spinner from '@/Components/UI/Spinner'
import axios from 'axios';

    export default {
        props: ["team_name", "video_id"],

        components: {
            AppLayout, LockClosedIcon, ArrowRightIcon,
            PaperAirplaneIcon, EnvelopeOpenIcon, Spinner,
            ExclamationCircleIcon,
        },
        data() {
            return {
                sending_link: false,
                link_sent: false,
                error: false,
            }
        },
        created() {
            // this.EventBus.on("start.call", function(toto) {
            //     this.test(toto)
            // }.bind(this));
            //console.log(this.is_visitor)
        },
        beforeUnmount() {
            // this.EventBus.off("start.call", this.test);
        },
        mounted() {
            // this.EventBus.emit("start.call", "hello")
        },
        methods: {
            sendLink() {
                if (this.link_sent || this.sending_link) {
                    return
                }
                this.sending_link = true

				let url = 'https://share.birdie.so/share/'+this.video_id+'/send-access-link';
				var params = { v: this.video_id };
				axios.post(url, params)
			    .then(response => {
                    this.error = false
                    this.link_sent = true
                    this.sending_link = false
		        })
		        .catch(e => {
		        	console.error(e)
                    this.error = true
                    this.sending_link = false
		        });


            }
            // test(toto) {
            //     console.log("test ok", toto)
            // }
        }
    }
</script>
